import React from 'react';

function Paragraph({ children, className = '', ...rest }) {
  return (
    <p className={`font-encode-sans ${className}`} {...rest}>
      {children}
    </p>
  );
}

export default Paragraph;
